import React, { useCallback, useContext } from 'react';
import { ReactEditor, useSlate } from 'slate-react';
import PropTypes from 'prop-types';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { Button, IconButton } from '@material-ui/core';
import { CustomSlateContext } from '../../CustomSlate';
import { focusEditor, getNodeType, toggleBlock, toggleMark } from '../../../utils';
import { SLATE_FORMAT_ACTIONS, SLATE_NODE_TYPES, SLATE_TEXT_FORMATS } from '../../../const';

export const ToggleFormatButton = ({
  format,
  className,
  classes,
  isLabelVisible,
  ...restProps
}) => {
  const editor = useSlate();
  const slateContext = useContext(CustomSlateContext);
  const formatAction = SLATE_FORMAT_ACTIONS[format];
  const { icon: Icon = HelpOutlineIcon, label = '' } = formatAction || {};

  const handleFormatClick = useCallback(
    (ev) => {
      ev.preventDefault();
      if (!ReactEditor.isFocused(editor)) {
        focusEditor(editor);
        return;
      }
      const formatType = getNodeType(format);
      if (!formatType) {
        return;
      }
      switch (formatType) {
        case SLATE_NODE_TYPES.BLOCK:
          toggleBlock(editor, format);
          break;
        case SLATE_NODE_TYPES.MARK:
          toggleMark(editor, format);
          break;
        case SLATE_NODE_TYPES.INLINE: {
          slateContext.setIsLinkInsertOpen(true);
          break;
        }
        default:
          break;
      }
    },
    [editor, format, slateContext]
  );

  return isLabelVisible ? (
    <Button
      classes={classes}
      className={className}
      startIcon={<Icon />}
      onMouseDown={handleFormatClick}
    >
      {label}
    </Button>
  ) : (
    <IconButton
      className={className}
      onMouseDown={handleFormatClick}
      {...restProps}
    >
      <Icon />
    </IconButton>
  );
};

ToggleFormatButton.propTypes = {
  format: PropTypes.oneOf(Object.values(SLATE_TEXT_FORMATS)).isRequired,
  className: PropTypes.string,
  isLabelVisible: PropTypes.bool,
  classes: PropTypes.shape({}),
};

ToggleFormatButton.defaultProps = {
  className: '',
  isLabelVisible: false,
  classes: null,
};
